import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Hero } from '../components/Hero';
import { About } from '../components/About';
import { WhatWeCover } from '../components/WhatWeCover';
import { HowWeWork } from '../components/HowWeWork';
import { Mission } from '../components/Mission';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function LandingPage() {
  const schemaOrgData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'SoftwarePair',
    url: 'https://softwarepair.com',
    logo: 'https://softwarepair.com/logo.png',
    description: 'Your trusted source for insights, comparisons, and practical guides on software, cybersecurity, and digital technology. Expert reviews and recommendations since 2009.',
    foundingDate: '2009',
    email: 'hello@softwarepair.com',
    sameAs: ['https://softwarepair.com'],
    areaServed: 'Worldwide',
    knowsAbout: ['Cybersecurity', 'Software Reviews', 'Artificial Intelligence', 'Cloud Computing', 'VPN Services', 'Data Security', 'Business Software', 'Web Development']
  };
  return <>
      <Helmet data-id="element-109">
        {/* Primary Meta Tags */}
        <title data-id="element-110">
          SoftwarePair - Expert Software Reviews, Cybersecurity & Tech Insights
        </title>
        <meta name="title" content="SoftwarePair - Expert Software Reviews, Cybersecurity & Tech Insights" data-id="element-111" />
        <meta name="description" content="Your trusted source for software reviews, cybersecurity insights, and practical technology guides. Expert comparisons and recommendations to help you choose the right digital tools since 2009." data-id="element-112" />
        <meta name="keywords" content="software reviews, cybersecurity, VPN, antivirus, cloud computing, AI technology, data security, business software, tech guides, software comparisons, digital privacy, online protection" data-id="element-113" />
        <meta name="author" content="SoftwarePair Team" data-id="element-114" />
        <meta name="robots" content="index, follow" data-id="element-115" />
        <meta name="language" content="English" data-id="element-116" />
        <meta name="revisit-after" content="7 days" data-id="element-117" />
        {/* Canonical Link */}
        <link rel="canonical" href="https://softwarepair.com" data-id="element-118" />
        {/* Open Graph Meta Tags */}
        <meta property="og:type" content="website" data-id="element-119" />
        <meta property="og:url" content="https://softwarepair.com" data-id="element-120" />
        <meta property="og:title" content="SoftwarePair - Expert Software Reviews, Cybersecurity & Tech Insights" data-id="element-121" />
        <meta property="og:description" content="Your trusted source for software reviews, cybersecurity insights, and practical technology guides. Expert comparisons and recommendations since 2009." data-id="element-122" />
        <meta property="og:image" content="https://softwarepair.com/og-image.png" data-id="element-123" />
        <meta property="og:site_name" content="SoftwarePair" data-id="element-124" />
        <meta property="og:locale" content="en_US" data-id="element-125" />
        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" data-id="element-126" />
        <meta name="twitter:url" content="https://softwarepair.com" data-id="element-127" />
        <meta name="twitter:title" content="SoftwarePair - Expert Software Reviews, Cybersecurity & Tech Insights" data-id="element-128" />
        <meta name="twitter:description" content="Your trusted source for software reviews, cybersecurity insights, and practical technology guides. Expert comparisons and recommendations since 2009." data-id="element-129" />
        <meta name="twitter:image" content="https://softwarepair.com/twitter-image.png" data-id="element-130" />
        {/* Schema.org Markup */}
        <script type="application/ld+json" data-id="element-131">
          {JSON.stringify(schemaOrgData)}
        </script>
      </Helmet>
      <div className="w-full min-h-screen bg-white" data-id="element-132">
        <Hero data-id="element-133" />
        <About data-id="element-134" />
        <WhatWeCover data-id="element-135" />
        <HowWeWork data-id="element-136" />
        <Mission data-id="element-137" />
        <Contact data-id="element-138" />
        <Footer data-id="element-139" />
      </div>
    </>;
}